module.exports = __webpack_public_path__ + "media/female_resultA.894648e0.mp3";